invHdApp.
  factory('Order', ['$http', function ($http) {
    return {
      dashboard: function (data) {
        return $http.post('api/dashboard', data);
      },
      calendar: function (data) {
        return $http.post('api/calendar', data);
      },
      dashboardOffice: function (data) {
        return $http.post('api/dashboard-office', data);
      },
      workers: function (e) {
        return $http.get('api/dashboard-workers', { params: e, ignoreLoadingBar: true });
      },
      order: function (id) {
        return $http.get('api/order/' + id);
      },
      newOrderData: function (params) {
        return $http.get('api/new-order', {params: params});
      },
      newOrder: function (e) {
        return $http.post('api/new-order', e);
      },
      orders: function (data) {
        return $http.post('api/orders', data);
      },
      searchOrders: function (data) {
        return $http.get('api/search-orders', { params: data });
      },
      notifications: function (data) {
        return $http.post('api/notifications', data);
      },
      sendNote: function (data) {
        return $http.post('api/send-note', data);
      },
      sendSms: function (data) {
        return $http.post('api/send-sms-customer', data);
      },
      sendCallRecord: function (data) {
        return $http.post('api/send-call-record', data);
      },
      refreshOrders: function () {
        return $http.get('api/refresh-orders');
      },
      updateOrder: function (data) {
        return $http.post('api/update-order', data);
      },
      tour: function (data) {
        return $http.post('api/tour', data);
      },
      getAddressFromCoord: function (url) {
        return $http.jsonp(url);
      },
      assignWorker: function (data) {
        return $http.post('api/assign-worker', data);
      },
      changeOrderStatus: function (data) {
        return $http.post('api/change-order-status', data);
      },
      loadRoute: function (id) {
        return $http.get('api/get-route/' + id);
      },
      sendComment: function (data) {
        return $http.post('api/send-comment-order', data);
      },
      changeWorkStatus: function (data) {
        return $http.post('api/change-work-status', data);
      },
      changeArrived: function (data) {
        return $http.post('api/change-work-arrived', data);
      },
      changeWorkStatusOffice: function (data) {
        return $http.post('api/change-work-status', data, { ignoreLoadingBar: true });
      },
      deleteWork: function (data) {
        return $http.post('api/delete-work', data);
      },
      deleteTask: function (data) {
        return $http.post('api/delete-task', data);
      },
      donwloadSampleExcel: function () {
        return $http.get('api/download-sample-order-excel');
      },
      remainingTime: function (id, loading) {
        if (typeof loading === 'undefined') {
          return $http.get('api/get-remaining-time/' + id);
        } else {
          return $http.get('api/get-remaining-time/' + id, {
            ignoreLoadingBar: true
          });
        }
      },
      generateTotalOrdersReportInZip: function (data) {
        return $http.post('api/download-total-orders-reports-in-zip', data);
      },
      removeDownloadFile: function (data) {
        return $http.post('api/remove-download-file', data);
      },
      generateExcelReport: function (data) {
        return $http.post('api/download-orders-reports-in-excel', data);
      },
      generateExcelReportNotification: function (data) {
        return $http.post('api/download-notification-reports-in-excel', data);
      },
      deleteOrders: function (data) {
        return $http.post('api/delete-orders', data);
      },
      assigOrders: function (data) {
        return $http.post('api/assign-orders', data);
      },
      assigOrdersRoute: function (data) {
        return $http.post('api/assign-orders-route', data);
      },
      getWorkersForOptimizing: function () {
        return $http.get('api/get-available-workers-for-optimization', {
          ignoreLoadingBar: true
        });
      },
      routeOptimization: function (data) {
        return $http.post('api/route-optimization', data, { ignoreLoadingBar: false });
      },
      getLatAndLngOfWorkerOrders: function (data) {
        return $http.post('api/get-lat-and-lng-of-worker-orders', data, { ignoreLoadingBar: true });
      },
      updateChecklist: function (data) {
        return $http.post('api/update-checklist', data);
      },
      updatePaymentData: function (data) {
        return $http.post('api/update-payment', data);
      },
      sendOffer: function (data) {
        return $http.post('api/send-offer', data);
      },
      assignOrderToRoute: function (data) {
        return $http.post('api/assign-order-to-route', data);
      },
      exportProof: function (id) {
        return $http.get('api/export-proof/' + id);
      },
      movement: function (data) {
        return $http.post('api/order-movement', data);
      },
      movementInit: function (data) {
        return $http.get('api/order-movement');
      },
      routeOrder: function (data) {
        return $http.post('api/route-order', data);
      },
      routeOrderInit: function (data) {
        return $http.get('api/route-order', data);
      },
      addRouteOrder: function (data) {
        return $http.post('api/add-route-order', data);
      },
      updateOrderField: function (data) {
        return $http.post('api/update-order-fields', data);
      },
      getBovoOrder: function (data) {
        return $http.get('api/bovo-order/' + data);
      },
      getKolayGelsinOrder: function (data) {
        return $http.get('api/kolaygelsin-order/' + data);
      },
      getPakettaxiOrder: function (data) {
        return $http.get('api/pakettaxi-order/' + data);
      },
      getNovaOrder: function (data) {
        return $http.get('api/nova-order/' + data);
      },
      duplicateWork: function (data) {
        return $http.post('api/duplicate-order/', data);
      },
      updateOrderWithoutSms: function (data) {
        return $http.post('api/update-order-without-sms', data);
      },
    };
  }]);